import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../lib/api-client.js';
import { useAuth } from '../features/auth/useAuth.js';

export function useUnreadDmCount() {
  const { dbUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!dbUser) return;
    try {
      const res = await apiClient.get<{ count: number }>('/messages/unread-count', {
        requireAuth: true,
      });
      setUnreadCount(res.count);
    } catch {
      // バッジ取得失敗は無視
    }
  }, [dbUser]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { unreadCount, refetch: fetchCount };
}
